export const OBTER_MENU_ATENDIMENTO_VIRTUAL_REQUEST =
  'OBTER_MENU_ATENDIMENTO_VIRTUAL_REQUEST';
export const OBTER_MENU_ATENDIMENTO_VIRTUAL_SUCCESS =
  'OBTER_MENU_ATENDIMENTO_VIRTUAL_SUCCESS';
export const OBTER_MENU_ATENDIMENTO_VIRTUAL_ERROR =
  'OBTER_MENU_ATENDIMENTO_VIRTUAL_ERROR';
